import { useMemo } from "react";
import { isUserOnMac } from "utils/navigator";
import { RightSlot } from "./ContextMenu";

interface KeyboardShortcutProps {
  shortcutKeys: string[];
}

export function KeyboardShortcut({ shortcutKeys }: KeyboardShortcutProps) {
  const replacements: Record<string, string> = useMemo(
    () => ({
      meta: isUserOnMac() ? "⌘" : "Ctrl",
      alt: isUserOnMac() ? "⌥" : "Alt",
      altgraph: isUserOnMac() ? "⌥" : "Alt",
      ctrl: "Ctrl",
      shift: "Shift",
    }),
    [],
  );

  const formattedShortcut = useMemo(() => {
    return shortcutKeys
      .map((key) => {
        const lowerCaseKey = key.toLocaleLowerCase();
        const formattedKey =
          key.length > 1
            ? // first letter to uppercase
              key.slice(0, 1).toLocaleUpperCase() + key.slice(1)
            : key.toLocaleUpperCase();
        return replacements[lowerCaseKey] ?? formattedKey;
      })
      .join("+");
  }, [shortcutKeys, replacements]);

  return (
    <RightSlot>
      <kbd>{formattedShortcut}</kbd>
    </RightSlot>
  );
}
